import React, { useEffect, useState } from "react";
import ProductCard from "../../component/ProductCard";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useMyGlobal } from "../../component/GlobalData";
import { Col, Container, Row, Image, Stack } from "react-bootstrap";
import { Button, Dimmer, Divider, Label, Loader, Icon, Breadcrumb, BreadcrumbSection, BreadcrumbDivider, Popup, Form as FormSuir, Input as InputSuir  } from "semantic-ui-react";
import noDataImg from "../../assets/no_data.png";
import ProductFilterClearance from "../../component/ProductFilterClearance";
import { getClearanceProducts } from "../../../api/clearanceApi";
import axios from "axios";

export const ClearancePage = () => {
    const navigate = useNavigate()
    const { token, windowWidth } = useMyGlobal()
    const dataDsc = useLocation().state
    const [prdDsc, setPrdDsc] = useState([])
    const [currentPage, setCurrentPage] = useState(0)
    const pagePerLoad = 8
    const [jmlProd, setJmlProd] = useState(pagePerLoad)
    const [loadMoreSpiner, setLoadMoreSpiner] = useState(false)
    const [loadFilter, setLoadFilter] = useState(false)
    const [hasMore, setHasMore] = useState(true);

    const [directLinkCat, setDirectLinkCat] = useState(null)
    
    const param = useParams()
    const category = useLocation().state
    const [originalProducts, setOriginalProducts] = useState([])
    const [products, setProducts] = useState([])
    const [colorList, setColorList] = useState([])
    const [brandList, setBrandList] = useState([])
    const [sizeList, setSizeList] = useState([])
    const [filterParams, setFilterParams] = useState(null)
    const [searchVal, setSearchVal] = useState('')
    
    const [listBrandonClearance, setListBrandonClearance] = useState([])
    
    const noData = !loadFilter && !loadMoreSpiner && prdDsc.length === 0
    
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 992);
        
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleFilterChange = (params) => {
        setFilterParams(params)
        setLoadFilter(true)

        // OPTION 1: filter dari local data dulu
        applyLocalFilter(params)

        // OPTION 2 (optional): kalau mau hit API ulang
        // reset & fetch ulang dari page
    }

    const applySort = (products, sortBy) => {
        if (!sortBy) return products

        return [...products].sort((a, b) => {

            // ON SALE priority
            if (sortBy.on_sale) {
                const aSale = a.isDiscounted === "1" ? 1 : 0
                const bSale = b.isDiscounted === "1" ? 1 : 0

                if (aSale !== bSale) {
                    return bSale - aSale
                }
            }

            // PRICE
            if (sortBy.price === 'asc') {
                //return a.final_price - b.final_price
                return Number(a.final_price) - Number(b.final_price)
            }

            if (sortBy.price === 'desc') {
                //return b.final_price - a.final_price
                return Number(b.final_price) - Number(a.final_price)
            }

            return 0
        })
    }

    const applyLocalFilter = (params) => {
        let data = [...originalProducts]

        if (params.brand && params.brand !== 0) {
            data = data.filter(i =>
                i.category_parent.some(c => c.id_category === params.brand)
            )
        }

        if (params.size) {
            data = data.filter(i => i.size.map(String).includes(String(params.size)))
        }

        if (params.color) {
            data = data.filter(i =>
                i.color.some(c => c.color_main.toLowerCase() === params.color.toLowerCase())
            )
        }

        if (params.priceMin != null && params.priceMax != null) {
            data = data.filter(i =>
                i.final_price >= params.priceMin &&
                i.final_price <= params.priceMax
            )
        }

        if (params.keyword) {
            const key = params.keyword.toLowerCase()
            data = data.filter(i =>
                i.product_name.toLowerCase().includes(key) ||
                i.id_product.toLowerCase().includes(key)
            )
        }

        // sorting
        data = applySort(data, params.sortBy)

        setPrdDsc(data)
        
        setLoadFilter(false)
    }

    const handleSearch = (e) => {
        e.preventDefault()

        setLoadFilter(true)

        const newParams = {
            ...(filterParams || {}),
            keyword: searchVal
        }

        setFilterParams(newParams)

        applyLocalFilter(newParams)
    }

    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 300 &&
                !loadMoreSpiner &&
                hasMore &&
                !loadFilter
            ) {
                handleClickLoadMore();
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [loadMoreSpiner, hasMore]);

    const getProductDiscount = async (halaman, jumlah) => {
        setLoadMoreSpiner(true)

        try {
                const res = await getClearanceProducts({
                    halaman,
                    jumlah,
                    token
                });

                let data = []
                let colors = []
                let brand = []
                let size = []

                if (res.state === 200 && res.data.length > 0) {
                    data = res.data

                    data.map((i, d) => i.category_parent.map((x) => brand.push(x)))
                    data.map((i, d) => i.color.map((x) => colors.push(x)))
                    data.map((i, d) => i.size.map((x) => size.push(x)))

                    setOriginalProducts(prev => {
                        const filteredData = data.filter(item =>
                            !prev.some(prevItem => prevItem.id_product === item.id_product)
                        )
                        return [...prev, ...filteredData]
                    })

                    setBrandList(Object.values(brand.reduce((acc, item) => {
                        if (!acc[item.id_category] && item.on_page === '1') {
                            acc[item.id_category] = {
                                id_category: item.id_category,
                                category_name: item.category_name,
                                on_page: item.on_page,
                            };
                        }
                        return acc
                    }, {})).sort((a, b) => a.category_name.localeCompare(b.category_name)))

                    
                    // GROUPING ARRAY SUPAYA GA DUPLICAT
                    setColorList(Object.values(colors.reduce((acc, item) => {
                        if (!acc[item.id_color]) acc[item.id_color] = {
                            id_color: item.id_color,
                            color_main: item.color_main,
                            color_secondary: item.color_secondary,
                            color_accent: item.color_accent
                        }

                        return acc
                    }, {})))

                    const sizeGroup = [...new Set(size)].map(String)
                    
                    const convertedNumericGroup = sizeGroup.map((value) => {
                        // Jika nilai adalah angka atau pecahan seperti '1½'
                        const numericValue = !isNaN(parseFloat(value)) ? parseFloat(value) : value;

                        return numericValue;
                    });
                    // Membuat dua array: satu berisi nilai numerik, satu berisi nilai yang tidak bisa diurutkan
                    const sortableValues = convertedNumericGroup.filter(value => typeof value === 'number');
                    const nonSortableValues = convertedNumericGroup.filter(value => typeof value !== 'number');

                    // Mengurutkan nilai numerik
                    const sortedNumericValues = sortableValues.sort((a, b) => a - b);

                    // Menggabungkan kembali nilai yang telah diurutkan dengan nilai yang tidak bisa diurutkan
                    const finalResult = [...sortedNumericValues, ...nonSortableValues];
                    setSizeList(finalResult);

                    setLoadMoreSpiner(false)
                    setHasMore(true)
                    /*
                    setPrdDsc(prevNew => {
                        const filteredData = data.filter(item =>
                            !prevNew.some(prevItem => prevItem.id_product === item.id_product)
                        )

                        const newData = [...prevNew, ...filteredData]

                        return newData
                    })
                    */
                    setOriginalProducts(prev => {
                        const filteredData = data.filter(item =>
                            !prev.some(prevItem => prevItem.id_product === item.id_product)
                        )

                        return [...prev, ...filteredData]
                    })
                    
                    setLoadFilter(false)
                } else {
                    setHasMore(false)
                    setLoadMoreSpiner(false)
                    
                    setLoadFilter(false)
                }

            } catch (error) {
                console.error(error);
                setLoadFilter(false)
                setLoadMoreSpiner(false)
            }
    }
/*
    const handleClickLoadMore = () => {
        setCurrentPage(currentPage + pagePerLoad)
        getProductDiscount(currentPage + pagePerLoad, jmlProd)
    }
*/
    const handleClickLoadMore = () => {
        if (loadMoreSpiner || !hasMore) return

        const nextPage = currentPage + pagePerLoad

        setCurrentPage(nextPage)

        getProductDiscount(nextPage, jmlProd)
    }

    useEffect(() => {
        const init = async () => {

            if (!dataDsc) {
                await getProductDiscount(0, jmlProd)
            } else {
                if (dataDsc.data.length > 0) {
                    setPrdDsc(dataDsc.data)
                    setOriginalProducts(dataDsc.data)
                } else {
                    await getProductDiscount(0, jmlProd)
                }
            }
        }

        init()

        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        if (filterParams && originalProducts.length > 0) {
            applyLocalFilter(filterParams)
        } else {
            setPrdDsc(originalProducts)
        }
    }, [originalProducts, filterParams])

    const getListBrandonClearance = async () => {
        await axios.get(
            "https://hoopsdevteam.com/api_web/controler/hoops/listbrand.php?index=2"
        )
        .then(res => {
            if (res.data.state === 200) {
                setListBrandonClearance(res.data.data)
                //ClearanceNew(0, jmlProd)
            }
        })
    }

 /*   
    const ClearanceNew = async (pages, jumlahData) => {

        const param = new URLSearchParams()
        param.append('page', pages)
        param.append('limit', jumlahData)

        param.append('brand', filter.brand || '')
        param.append('size', filter.size || '')
        param.append('color', filter.color || '')
        param.append('price_min', filter.priceMin || '')
        param.append('price_max', filter.priceMax || '')


        await axios({
            method: "POST",
            url: `${process.env.REACT_APP_ERP_URL}api_web/controler/hoops/clearance.php?index=2`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
        .then((response) => {
            console.log(response.data.data)
        })
    }
*/

    useEffect(() => {
        getListBrandonClearance()
    }, [])

    return (
        <section>
            {/* BANNER
            <div className="banner-outer">
                <div className="banner-inner">
                    <img
                        className="img-fluid d-block w-100"
                        src="https://hoopsdevteam.com/assets/category/main/header/category_65a4fec3090f9.webp"
                        alt="banner"
                    />
                </div>
            </div> */}
            <div className="banner-outer">
                <div className="banner-inner">
                    <img
                        className="img-fluid d-block w-100"
                        src={category ? category.header_image : directLinkCat ? directLinkCat.header_image : ''}
                        alt="banner"
                    />
                </div>
            </div>

            {/* CONTENT */}
            <Container fluid="xl">
                
                {isMobile && (
                    <Row className="mt-1" style={{padding: '15px 15px 15px 15px !important'}}>
                        <Col className="text-start col-12">
                                <Breadcrumb size="tiny">
                                    <BreadcrumbSection link onClick={() => navigate(`/`)}>HOME</BreadcrumbSection>
                                    <BreadcrumbDivider/>
                                    <BreadcrumbSection active>CLEARANCE PRODUCT</BreadcrumbSection>
                                </Breadcrumb>
                        </Col>
                    </Row>
                )}

                <Row className="mt-5 mb-10">
                    <Col xl={12} lg={12} md={12}>
                        <h1 className="display-5">CLEARANCE</h1>
                        { isMobile ? 
                            (   
                                <>
                                    <h3 className="fw-light mb-3" style={{ textAlign: 'justify', fontSize: '1em' }}>
                                        Welcome to the Clearance section at Hoops Indonesia. Here you will find a curated mix of products from all top brands – including original footwear, apparel, and accessories – at special prices. You may discover last season's favorites or even display pieces that are still in great condition. Every product is 100% authentic, so you can shop with confidence. Whether you are hunting for a deal or looking for something unique, Hoops Indonesia offers you a smart way to grab quality gear. Stock changes fast. Do not miss out.
                                    </h3>
                                    <h3 className="text-uppercase fw-bold" style={{ fontSize: '0.9em' }}>The product might sell out soon, so check out the items you want right away.</h3>
                                </>
                            ):( 
                                <>
                                    <h3 className="fs-5 fw-light" style={{textAlign: 'justify'}}>
                                        Welcome to the Clearance section at Hoops Indonesia. Here you will find a curated mix of products from all top brands – including original footwear, apparel, and accessories – at special prices. You may discover last season's favorites or even display pieces that are still in great condition. Every product is 100% authentic, so you can shop with confidence. Whether you are hunting for a deal or looking for something unique, Hoops Indonesia offers you a smart way to grab quality gear. Stock changes fast. Do not miss out. 
                                    </h3>
                                    <Divider className="mt-5" horizontal><h3 className="fs-6 mt-1">The product might sell out soon, so check out the items you want right away.</h3></Divider>
                                </>
                        )}
                    </Col>
                </Row>

                <Row className="mt-5 align-items-start" style={{ padding: "0 0rem" }}>
                    {/* LEFT: FILTER */}
                    <Col xl={3} className="filter-sidebar-2" lg={4} md={12}>
                    {/*
                        <ProductFilterClearance
                            setProducts={(category?.hasOwnProperty('search_value')) ? null : setPrdDsc}
                            categoryId={param.categoryId}
                            categoryFrom={category?.from}
                            colorList={colorList}
                            brandList={brandList}
                            sizeList={sizeList}
                            doGetProduct={false}
                            originalData={originalProducts} // ✅ tambah ini
                        />
                    */}
                        <ProductFilterClearance
                            onFilterChange={handleFilterChange}
                            originalData={originalProducts}
                            colorList={colorList}
                            brandList={listBrandonClearance}
                            sizeList={sizeList}

                            searchVal={searchVal}
                            setSearchVal={setSearchVal}
                            handleSearch={handleSearch}
                        />
                    </Col>

                    {/* RIGHT: PRODUCT */}
                    <Col xl={9} lg={8} md={12}>
                        {!isMobile && (
                                <Row className="mb-3 filter-searchbar">
                                    <Col className="text-start col-6">
                                            <Breadcrumb size="tiny">
                                                <BreadcrumbSection link onClick={() => navigate(`/`)}>HOME</BreadcrumbSection>
                                                <BreadcrumbDivider/>
                                                <BreadcrumbSection active>CLEARANCE PRODUCT</BreadcrumbSection>
                                            </Breadcrumb>
                                    </Col>
                                    <Col className="text-end col-6">
                                        <FormSuir onSubmit={handleSearch}>
                                            <Popup
                                                trigger={
                                                <InputSuir
                                                    value={searchVal}
                                                    onChange={(e) => setSearchVal(e.target.value)}
                                                    icon={{ name: "search", link: true }}
                                                    placeholder="Search in clearance"
                                                />
                                                }
                                                content="Type Name or Article and then press Enter"
                                            />
                                        </FormSuir>
                                    </Col>
                                </Row>
                            )
                        }

                        <Row className="d-flex justify-content-start mb-3 mt-3">
                            {/* 
                            <Dimmer active={isLoading} inverted><Loader active={isLoading}>Loading</Loader></Dimmer>
                            <div className="mt-3" style={noData ? { display: 'block' } : { display: 'none' }}>
                                <Image
                                    src={noDataImg}
                                    width={200}
                                    height={200}
                                />
                            </div>
                            */}
                            
                            {/* load && (
                                <Col xs={12} className="text-center py-5">
                                    <Loader active inline="centered" size="large">
                                        Loading Products...
                                    </Loader>
                                </Col>
                            )*/}
                            
                            { loadFilter && (
                                <Col xs={12} className="text-center py-5">
                                    <Loader active inline="centered" size="large">
                                        Finding Products...
                                    </Loader>
                                </Col>
                            )}
                            
                            <Col className="text-center py-5 mt-3" style={noData ? { display: 'block' } : { display: 'none' }}>
                                <Stack gap={3} className="align-items-center">
                                    <Icon
                                        name="search"
                                        size="huge"
                                        color="grey"
                                    />

                                    <div>
                                        <h4 className="mb-2">
                                            Oops! No products found.
                                        </h4>

                                        <p className="text-muted mb-0">
                                            Please try adjusting your search, or feel free to explore our other products.
                                        </p>
                                    </div>
                                </Stack>
                            </Col>
                            {
                                prdDsc.map((item, i) =>
                                    <ProductCard data={item} key={i} />
                                )
                            }
                            <Col md={12} className="d-flex justify-content-center pe-2 mb-5">
                                {
                                    hasMore ?
                                        <div className="pb-2 mt-5" style={{ height: "20px", textAlign: "center" }}>
                                            {
                                                loadMoreSpiner ?
                                                    <Loader active inline size="small" />
                                                    :
                                                    <Icon name="angle double down" size="big" className="bounce" />
                                            }
                                        </div>
                                        :
                                        <>
                                            {/*
                                            <div style={{ height: "20px", textAlign: "center" }}>
                                                <p>All product has been loaded</p>
                                            </div> 
                                            */}
                                        </>
                                }
                            </Col>
                        </Row>
                    </Col>
                </Row>
                
                <Row className="mt-5 align-items-start" style={{ padding: "0 2rem" }}>
                    <Col lg={12} md={12} sm={12} className="justify-items-start">
                        <h1 className="fs-5">HOOPS INDONESIA SALE FOR MEN AND WOMEN PRODUCTS</h1>
                        <h4 className="fw-light mt-0">
                            Score big with our limited-time sale on premium basketball gear, apparel, and shoes—perfect for every hoops enthusiast in Indonesia. Whether you're training for competition or playing pickup games with friends, our collection offers breathable basketball apparel, high-traction shoes, and durable gear trusted by athletes across the country. Featuring top brands like Nike, Adidas, and Under Armour, this is your chance to upgrade your court essentials at unbeatable prices. From Medan to Bali, hoops Indonesia players know where to find quality and style. Don’t miss out—shop now and elevate your game before the final buzzer
                        </h4>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}